import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
// import {FormGroup} from '../../form/FormOpsV2'

class LugaresV2 extends FormComponent {


  // state = {
  //   Form: new Form([
  //     Form.Field('text', 'od_lugar', 'Clave', '', [Validators.required], 4),
  //     Form.Field('text', 'od_lugar_nombre', 'Nombre del lugar', '', [Validators.required], 4),
  //     Form.Field('select', 'od_select', 'Select', '', [Validators.required], 4, [{ Value: 1, Label: 'Uno' }, { Value: 2, Label: 'Dos' }]),
  //   ], ['Guardar'], 'Lugar')
  // }

  // formChange = (form, field) => { this.setState({ Form: Form.Change(form, field) }) }
  // onSubmit = (op, val) => { }

  // componentDidMount() {
  //   // this.setState({ Form: Form.ValueChange(this.state.Form, { od_lugar: this.odSelectChange }) })
  // }

  // odSelectChange = (field) => {
  //   // this.setState({Form: Form.Patch(this.state.Form, {od_select: 2})})
  //   // this.setState({ Form: Form.FieldOptions(this.state.Form, 'od_select', [{v: 1, l: 'PROBANDO'}], 'v', 'l') })
  // }

  // render() {
  //   return (
  //     <div>
  //       <DynamicForm form={this.state.Form} formChange={this.formChange} onSubmit={this.onSubmit} />
  //     </div>
  //   )
  // }

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'lugar/one', saveUrl: 'lugar/save', backUrl: '/Catalogo/Lugares' },
      new Form([
        Form.Field('text', 'od_lugar', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'od_lugar_nombre', 'Nombre del lugar', '', [Validators.required], 8),
        // Form.Field('select', 'od_select', 'Select', '', [Validators.required], 4, [{ Value: 1, Label: 'Uno' }, { Value: 2, Label: 'Dos' }]),
      ], ['Guardar'], 'Lugar'), this.formData
    )
    // console.log(this.props.match)
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    var Res = await Http.get('cliente/form-generales');
    // console.log(Res.data);
    if (!Res.error) {
      // var estados = Form.FieldOptions(form, 'od_select', Res.data.estados, 'id', 'estado_nombre');
      // return estados;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(LugaresV2)
